<template>
  <TitleCard :title="titleCard"
             :showMore="showMore">
    <div class="backStack-table-wrap">
      <div class="head-top-wrap">
        <div class="form-table-wrap">
          <Form ref="form"
                layoutType="grid"
                :optionList="formRow"
                :defaultModel="defaultValue"></Form>
          <div class="operation-wrap">
            <a-button @click="clearAll">清空条件</a-button>
            <a-button @click="toSearch">搜索</a-button>
          </div>
        </div>
        <TableToolsWrap needLeft
                        :btnList="utilsBtnList"
                        @utilsClick="handlerActionClick"
                        @importChange="importChange"
                        :url="url"></TableToolsWrap>
      </div>
      <Table ref="table"
             :options="fields"
             :tableValue="tableValue"
             :customSlotOpt="slotOpt"
             :otherOpt="customOtherOpt"
             @change="initTableValue"
             @actionClick="handlerActionClick"></Table>
    </div>
    <AModal ref="modal"
            :customOpt="customModalOpt"
            @ok="handlerOk"></AModal>
    <SystemUser v-if="isShowAdd"
                @cancel="cancel"
                @addSuccess="addSuccess"></SystemUser>
  </TitleCard>
</template>

<script>
import Table from '../../components/table/index.vue'
import Form from '../../components/formTable/form.vue'
import TableToolsWrap from '../../components/common/tableToolsWrap.vue'
import SystemUser from './components/addUser'
import AModal from '../../components/AModal'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { fields, slotOpt, formRow } from './configs/config'
import {
  getUserInfo,
  statusUserInfo,
  // addUserInfo,
  deleteUserInfo,
  importUserInfo,
} from '@/api/systemUser.js'

const baseUrl = process.env.VUE_APP_BASE_URL
export default {
  mixins: [mixinsBackStack],

  data() {
    return {
      fields,
      slotOpt,
      formRow,
      tableValue: [],
      utilsBtnList: [
        { name: '启用', cb: 'enableUse' },
        { name: '禁用', cb: 'disableUse' },
        { name: '新增', cb: 'createUser' },
        { name: '删除', cb: 'batchDelete' },
        { name: '导入', cb: 'importFile' },
        { name: '模板下载', cb: 'downTemplate' },
      ],
      defaultSearchParam: {}, // 默认筛选条件
      defaultValue: {},
      customOtherOpt: {
        pagination: {
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
      },
      isShowAdd: false,
      url: baseUrl + '/system/user/importData',
      modeTemplate: process.env.VUE_APP_DEAL_DOWN_TEMPLATE || '',
    }
  },
  components: {
    Table,
    Form,
    AModal,
    TableToolsWrap,
    SystemUser,
  },
  mounted() {
    this.initTableValue()
  },
  methods: {
    importFile() {},
    importChange(e) {
      if (e.file.response) {
        let { code, msg } = e.file.response
        if (code === 200) {
          this.$message.success('导入成功!')
          this.initTableValue()
        } else {
          this.$message.warning(msg)
        }
      }
    },
    async initTableValue() {
      try {
        this.loadingTable(true)
        const params = this.dealSearchFormParams()
        const { rows, total } = await getUserInfo(params, {
          userName: params.userName,
        })
        const row = this.handlerDateFormat(rows)
        this.handlerResultMappings(row) // 处理数据的映射关系
        this.tableValue = row
        this.customOtherOpt.pagination.total = total
        this.initSelectedRowIds() // 清空勾选的选项
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      } finally {
        this.loadingTable(false)
      }
    },
    // 处理搜索表单的值
    dealSearchFormParams() {
      const { pagination } = this.$refs.table
      const { pageSize, pageNum } = pagination
      return { ...this.searchParam, pageSize, pageNum }
    },
    // 批量操作
    async batch(status, id) {
      if (id.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的内容')
      }
      const params = { ids: id, useStatus: `${status}` }
      const res = await statusUserInfo(params)
      if (res.code === 500) {
        this.$apiStatusHandler(99, res.msg)
        return
      }
      this.initTableValue()
    },
    // 处理工具栏的按钮的回调事件
    // 启用
    enableUse() {
      const ids = this.$refs.table.selectedRowIds
      const idstatus = ids.map((item) => item.useStatus)
      if (idstatus.includes('0')) {
        return
      }
      const id = ids.map((item) => item.id)
      this.batch(0, id)
    },
    // 禁用
    disableUse() {
      const ids = this.$refs.table.selectedRowIds
      const idstatus = ids.map((item) => item.useStatus)
      if (idstatus.includes('1')) {
        return
      }
      const id = ids.map((item) => item.id)
      this.batch(1, id)
    },
    // 创建用户
    async createUser() {
      this.isShowAdd = true
    },
    // 批量删除
    async batchDelete() {
      const ids = this.$refs.table.selectedRowIds
      const id = ids.map((item) => item.id)
      if (id.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的内容')
      }
      this.customModalOpt.contentTips = '是否确定删除已选用户'
      this.beforeShowModal(true, {
        source: 'batchDeleteApi',
        params: { ids: id.join(',') },
      })
    },
    async batchDeleteApi(params) {
      const { ids } = params
      try {
        this.loadingTable(true)
        const { msg, code } = await deleteUserInfo(ids)
        this.$apiStatusHandler(code, msg)
        this.initTableValue()
      } catch (error) {
        this.$apiStatusHandler(99, error)
      } finally {
        this.loadingTable(false)
      }
    },
    // 单个删除
    async delete(row) {
      // if (row.useStatus === '0') {
      //   return this.$apiStatusHandler(999, '只能删除已禁用的用户')
      // }
      this.customModalOpt.contentTips = '是否确定删除该用户'
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: { ids: row.id },
      })
    },
    async dealDeleteApi(params) {
      const { ids } = params
      try {
        this.loadingTable(true)
        const { msg, code } = await deleteUserInfo(ids)
        this.$apiStatusHandler(code, msg)
        this.initTableValue()
      } catch (error) {
        this.$apiStatusHandler(99, error)
      } finally {
        this.loadingTable(false)
      }
    },
    // 导入用户信息
    async input(data) {
      const { code, msg } = await importUserInfo(data)
      this.$apiStatusHandler(code, msg)
      // console.log(res)
    },
    // 下载
    downTemplate() {
      const a = document.createElement('a')
      a.setAttribute('download', '用户导入模板')
      a.setAttribute('href', this.modeTemplate)
      a.click()
      // console.log(export_table_to_excel)
      // t.loading = true
      // export_table_to_excel({ ref: this.$refs.table });
      // t.loading = false
      // this.$nextTick(() => {

      // })
    },
    cancel() {
      this.isShowAdd = false
    },
    addSuccess() {
      this.isShowAdd = false
      this.initTableValue()
    },
  },
}
</script>
